<template>
  <div :loading="loading">
    <a-row>
      <a-col :span="5" v-if="isPad">
        <patient-info-card :patient="patient" :is-pad="isPad" class="patient-info-card">
          <a-row class="info-row" style="margin-top: 5px">
            <a-col :span="12" class="center-panel">
              <a-button style="width: 95%" type="primary" :size="isPad?'small':'default'" @click="handleView"> 详细资料 </a-button>
            </a-col>
            <a-col :span="12" class="center-panel">
              <status-tag :status="patient.status"></status-tag>
            </a-col>
          </a-row>
        </patient-info-card>
      </a-col>
      <a-col :span="isPad?19:24">
        <div v-if="this.period.groupSet ==='0'">
          选择周期：<a-select v-model="selectedKey" style="width: 300px;margin-bottom: 10px" @change="handleChange">
          <a-select-option :value="item.id" v-for="(item,index) in followList" :key="index" >
            {{item.name}}
          </a-select-option>
        </a-select>        
        </div>
        <div v-else style="display: flex;">
          <a-tabs v-model="tabActiveKey" type="card" @change="groupChange">
            <a-tab-pane v-for="(tab,index) in followGroupList" :key="index" :tab="renderTab(tab)"></a-tab-pane>
          </a-tabs>
          <a-button type="primary" @click="groupTypeHandle" style="margin-top:8px; margin-left:10px;">添加{{this.period.groupTypeName}}</a-button>
        </div>
        <a-row class="follow-row center-panel" >
          <template v-if="this.period.groupSet ==='0'">
            <a-col :span="isPad?7:6" v-for="(item,index) in followList" :key="index" >            
              <follow-period-card  :data="item" style="width: 90%;margin-bottom: 5px" :selected="selected(item)" @unload="loadData" @click="selectChange(item)"></follow-period-card>
            </a-col>
          </template>
          <template v-else>
            <a-col :span="isPad?7:6" v-for="(item,index) in followGroupPeriodList" :key="index" >            
              <follow-period-card  :data="item" style="width: 90%;margin-bottom: 5px" :selected="selected(item)" @unload="loadData" @click="selectChange(item)"></follow-period-card>
            </a-col>
          </template>
          <!-- <a-col :span="isPad?10:6" v-if="patient.createdPeriod!=='1'">
            <div style="width: 100%; margin-bottom: 5px;border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;padding: 7px;">
              <div style="line-height: 50px">
                暂未生成随访计划，如需生成请点击【启动随访】
              </div>
              <div style="line-height: 50px;">
                <a-button type="primary" @click="startPeriodHandle">启动随访</a-button>
              </div>
            </div>

          </a-col> -->
        </a-row>
      </a-col>
    </a-row>
    <div>
      <a-row>
        <a-col :span="12" class="panel" style="text-align: left">
          <slot name="btn-left"></slot>
        </a-col>
        <a-col :span="12" class="panel" style="text-align: right">

          <a-button  v-if="getCurrentPeriod().halfway==='1'" @click="handleEditPeriod">删除/编辑计划外周期</a-button>
          <!-- <a-button type="primary" style="margin-left: 20px" :size="isPad?'small':'default'" icon="line-chart" @click="trendView">趋势指标</a-button> -->
          <slot name="btn"></slot>
        </a-col>
      </a-row>

      <form-table ref="form-table"  class="panel" @unload="loadData" :dataSource="formList"></form-table>
    </div>
    <trend-modal ref="trendModal" :id="patient.id" :width="isPad?'100%':'80%'"></trend-modal>
    <a-modal
      :title="`修改${projectPeriod.baseName||'基线'}日期`"
      :width="800"
      :visible="baseDateView"
      :confirmLoading="loading"
      @ok="startPeriodOk"
      @cancel="baseDateView = false">
      {{projectPeriod.baseName||'基线'}}日期：<a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
    </a-modal>
    <a-modal
      :title="`添加${this.period.groupTypeName||'分组'}`"
      :width="600"
      :visible="groupTypeView"
      :confirmLoading="loading"
      @ok="groupTypeOk"
      @cancel="groupTypeView = false">
      
      <!-- 使用 a-row 和 a-col 创建网格布局 -->
      <a-row :gutter="[16, 24]">
        <!-- 左上角部分 -->
        <a-col :span="12">
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in leftTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>              
            </a-col>
          </a-row>
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in leftBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>

        <!-- 右上角部分 -->
        <a-col :span="12">
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in rightTopNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
          <a-row :gutter="6">
            <a-col :span="3" v-for="(num, index) in rightBottomNumbers" :key="index">
              <div :class="['number-cell', { active: addGroupName === num}]" @click="selectGroup(num)">{{ num }}</div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 24]">
        <a-col :span="6" style="text-align: right">          
          复制{{this.period.groupTypeName||'分组'}}：
        </a-col>
        <a-col :span="18">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="isCopyGroup" @change="onSwitchChange" />
        </a-col>
      </a-row>
      <a-row :gutter="[16, 24]" v-if="isCopyGroup==1">
        <a-col :span="6" style="text-align: right">
          选择复制{{this.period.groupTypeName||'分组'}}：
        </a-col>
        <a-col :span="18">
          <a-select v-model="copyGroupId" style="width: 185px;margin-bottom: 10px" allowClear placeholder="请选择">
            <a-select-option :value="item.groupId" v-for="(item,index) in followGroupList" :key="item.groupId" v-if="item.base!=1">
              {{item.groupName}}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>

      <a-row :gutter="[16, 24]" v-if="isCopyGroup==0">
        <a-col :span="6" style="text-align: right">
          随访开始日期：
        </a-col>
        <a-col :span="18">
          <a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
        </a-col>
      </a-row>      

      <!-- <a-row>
        <a-col :span="6" style="text-align: right;">
          {{this.period.groupTypeName||'分组'}}：          
        </a-col>
        <a-col :span="18" style="margin-bottom: 16px">
          <a-select v-model="addGroupName" style="min-width:150px;" allow-clear showSearch>
            <a-select-option :value="item.text" v-for="(item,index) in enableAddGroupList" :key="index" >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" style="text-align: right">
          随访开始日期：
        </a-col>
        <a-col :span="18">
          <a-date-picker value-format='YYYY-MM-DD' v-model="baseDate" />
        </a-col>
      </a-row> -->
    </a-modal>
    <period-modal ref="periodModal" @ok="loadData" :patient-id="patient.id"></period-modal>
    <patient-edit ref="patient-edit" :width="isPad?'100%':'60%'" :fieldList="fieldList" ></patient-edit>
  </div>
</template>

<script>
  import { getAction,postAction,deleteAction } from '@/api/manage'
  import FollowPeriodCard from './followperiod/FollowPeriodCard'
  import FormTable from './followperiod/FormTable'
  import TrendModal from './followperiod/TrendModal'
  import PeriodModal from './followperiod/addperiod/PeriodModal'
  import PatientInfoCard from './PatientInfoCard'
  import PatientEdit from './PatientEdit'
  import StatusTag from './StatusTag'
  export default {
    name: 'FollowPeriod',
    components: { StatusTag, PatientEdit, PatientInfoCard, PeriodModal, TrendModal, FormTable, FollowPeriodCard, },
    props:{
      patient:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      projectPeriod:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      loadPatient:{
        type:Function,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {
        baseDateView:false,
        loading:false,
        fieldList:[],
        selectedKey:'',
        followList:[],
        formList:[],
        baseDate:'',
        isPad:this.$route.fullPath.startsWith('/pad'),
        cachePeriodKEY:'CACHE_PERIOD_LOAD_INFO',
        period:{},
        followGroupPeriodList:[],
        groupTypeView:false,
        addGroupName:'',
        tabActiveKey: 0,
        leftTopNumbers: [17, 16, 15, 14, 13, 12, 11],
        leftBottomNumbers: [47, 46, 45, 44, 43, 42, 41],
        rightTopNumbers: [21, 22, 23, 24, 25, 26, 27],
        rightBottomNumbers: [31, 32, 33, 34, 35, 36, 37],
        copyGroupId:'',
        isCopyGroup:0,
      }
    },
    computed:{
      followGroupList () {
        let group = []
        this.followList.forEach(period=>{
          if(period.groupName && period.groupId && !group.some(item => item.groupId === period.groupId)){
            group.push({"groupId":period.groupId,"groupName":period.groupName,"groupStatus":period.groupStatus,"base":period.base})
          }          
        });
        if(group.length>0){
          group.sort((a, b) => a.groupId - b.groupId);
        }
        return group
      },
      enableAddGroupList(){
        let groups = this.period.dictItemList||[]
        let temps = []
        // let exists = this.followGroupList
        groups.forEach(g=>{
          // if(exists.indexOf(g.text)<0){
            temps.push(g)
          // }
        })
        return temps;
      },    
    },
    mounted(){
      if(this.isPad && sessionStorage.getItem(this.cachePeriodKEY)){
        // 缓存
        this.selectedKey = sessionStorage.getItem(this.cachePeriodKEY)
      }
      this.loadData()
      getAction('/project/projectPatientField/list',{projectId:this.patient.projectId}).then(res=>{
        if(res.success){
          this.fieldList = res.result
        }
      })
      // this.loadPeriod()
    },
    methods:{
      onSwitchChange(checked) {
        this.isCopyGroup = checked ? 1 : 0
      },
      loadTableData(){
        this.handleChange()
      },
      getSelectRowsInfo(){
        return this.$refs['form-table'].getSelectRowsInfo()
      },
      handleView(){
        this.$refs['patient-edit'].view(this.patient)
      },      
      loadPeriod(callBack){
        getAction('/project/projectPeriod/getPeriodDetail',{projectId:this.patient.projectId}).then(res=>{
          if(res.success){
            this.period = res.result
            if(this.period.groupSet==='0'){
              console.log("loadPeriod-callBack")
              callBack()              
            }else{
              this.groupChange(this.tabActiveKey)
            }
          }
        })
      },
      loadData(){
        getAction('/patient/patientPeriodItem/list',{patientId:this.patient.id}).then(res=>{
          if(res.success){
            this.followList = res.result
            this.loadPeriod(m=>{
            if(this.followList.length>0 ){
              if(!this.selectedKey){
                if(this.patient.inPeriodItemIds){//受试者当前的访视周期
                  let periodIds = this.patient.inPeriodItemIds.split(",");
                  // let periodId = periodIds[periodIds.length-1]
                  let periodId = periodIds[0] // 修改为默认展示未完成的第一个周期
                  let follow
                  let index = 0;
                  for (let i = 0; i < this.followList.length; i++) {
                      if (this.followList[i].periodItemId === periodId) {
                      follow = this.followList[i]
                      break
                    }
                    index++
                  }
                  if (follow) {                  
                    this.selectChange(follow)
                    this.cur = index
                    return
                  }
                }
                this.selectChange(this.followList[0])
              }else{
                console.log("this.selectedKey："+this.selectedKey)
                let follow = null
                this.followList.forEach(item=>{
                  if(item.id===this.selectedKey){
                    follow = item
                  }
                })
                if(follow){
                  this.selectChange(follow)
                }
                else{
                  this.selectChange(this.followList[0])
                }
              }
            }
            })
          }
        })
      },
      groupTypeHandle(){
        this.addGroupName =''
        this.groupTypeView=true
      },
      //给受试者添加分组周期
      groupTypeOk(){
        let groupType = this.period.groupTypeName || '分组'
        if(!this.addGroupName){          
          return this.$message.warning('请选择'+groupType)
        }
        if(this.isCopyGroup==0){
          if(!this.baseDate){
            return this.$message.warning('请选择随访日期')
          }
          this.copyGroupId = ''
        }
        if(!this.copyGroupId && this.isCopyGroup==1){
          return this.$message.warning('请选择复制'+groupType)
        }
        this.loading = true
        this.addGroupName = groupType+this.addGroupName
        postAction('/patient/patient/addGroupPeriod',{patientId:this.patient.id,baseDate:this.baseDate,groupName:this.addGroupName,copyGroupId:this.copyGroupId}).then(res=>{
          if(res.success){
            this.groupTypeView=false            
            this.loadData()
            this.loadPatient()
            this.baseDate=''
            this.addGroupName=''
            this.tabActiveKey = 0
          }else{
            this.$message.warning(res.message)
            this.addGroupName=''
          }
        }).finally(()=>{
          this.addGroupName=''
          this.loading = false
        })
      },
      startPeriodHandle(){
        this.baseDateView=true
      },
      startPeriodOk(){
        if(!this.baseDate){
          return this.$message.warning('请选择基点日期')
        }
        this.loading = true
        postAction('/patient/patient/startPeriod',{id:this.patient.id,baseDate:this.baseDate}).then(res=>{
          if(res.success){
            this.baseDateView=false
            this.loadData()
            this.loadPatient()
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      selected(item){
        return this.selectedKey===item.id
      },
      selectChange(item){
        this.selectedKey = item.id
        sessionStorage.setItem(this.cachePeriodKEY,item.id)
        this.handleChange()
        //将当前周期id发送给父组件
        this.$emit('currentPeriodId', this.selectedKey);
      },
      handleChange(){
        this.loading = true
        getAction('/patient/patientForm/list',{periodItemId:this.selectedKey}).then(res=>{
          if(res.success){
            let i =0
            res.result.forEach(row => {
              if(!!row.children && row.children.length > 0){
                this.$set(row, 'id', "parent"+i);
                i++
              }
            })
            this.formList = res.result
            console.log(this.formList)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      trendView(){
        this.$refs['trendModal'].view()
      },
      handleAddPeriod(){
        this.$refs.periodModal.add()
      },
      getCurrentPeriod(){
        let current = {}
        this.followList.forEach(item=>{
          if(item.id===this.selectedKey){
            current = item
          }
        })
        return current
      },
      handleEditPeriod(){
        const current = Object.assign({},this.getCurrentPeriod());

        this.$refs.periodModal.edit(current,this.formList)
      },
      groupChange(key){
        if(this.followGroupList && this.followGroupList.length>0){
          if(key>this.followGroupList.length-1){
            key = 0
            this.tabActiveKey = key
          }
          this.followGroupPeriodList = this.followList.filter(period=>period.groupId===this.followGroupList[key].groupId)
          this.selectChange(this.followGroupPeriodList[0])
        }
      },
      renderTab(pane) {
        const warningMark = pane.groupStatus==='2' ? (
          <a-tooltip placement="topLeft" style="padding-right:2px">
            <template slot="title">
              已终止随访
            </template>
            <a-icon type="info-circle" style="color: #FF4500" />
          </a-tooltip>
        ) : null;
        const deleteIcon = pane.base!=1 ?(
          <a-tooltip placement="topLeft" style="padding-right:2px" v-has="del:period:group">
            <template slot="title">
              删除
            </template>
            <a-icon 
              type="close" 
              class="tab-close-icon"
              onClick={(e) => this.handleDeleteGroup(e, pane)} 
            />
          </a-tooltip>          
        ): null;
        return (
          <span class="custom-tab-header">
            {warningMark}
            <span class="tab-title">{pane.groupName}</span>
            {deleteIcon}        
          </span>
        );
      },
      selectGroup(num){
        this.addGroupName = num
      },
      handleDeleteGroup(e, pane) {
        // 【关键】阻止事件冒泡，防止点击删除图标时触发 a-tabs 的 @change 切换事件
        e.stopPropagation();
        var that = this;
        // 二次确认
        this.$confirm({
          title: '确认删除',
          content: `确定要删除 "${pane.groupName}" 吗？`,
          okText: '确认删除',
          okType: 'danger',
          cancelText: '取消',
          onOk: () => {
            that.loading = true
            deleteAction('/patient/patientPeriodItem/deletePeriodGroup',{id:pane.groupId}).then(res=>{
              if(res.success){
                this.loadData()
                this.loadPatient()
                // this.selectChange(this.followList[0])                
                this.tabActiveKey = 0
              }else{
                this.$message.warning(res.message)
              }
            }).finally(()=>{
              that.loading = false
            })
          },
        });
      },
    }
  }
</script>

<style scoped lang="less">
  .follow-row{
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
  }
  .panel{
    margin-top: 10px;
  }
  .patient-info-card{
    margin: 5px;
  }
  .number-cell {
    text-align: center;
    line-height: 30px; /* 根据需要调整 */
    border: 1px solid #ccc; /* 添加边框 */
    margin-bottom: 8px; /* 调整间距 */
    border-radius: 10px; /* 添加圆角 */
  }
  /* 悬停状态 */
        .number-cell:hover {
            background: #b9babb;
            border-color: #c0c4cc;
            cursor: pointer;
        }

        /* 选中状态 */
        .number-cell.active {
            background: #409eff;
            color: white;
            border-color: #409eff;
        }
        /* 容器布局：让文字和图标横向排列，垂直居中 */
      .custom-tab-header {
        // display: inline-flex;
        align-items: center;
        // justify-content: center;
        gap: 6px; /* 警告图标、文字、删除图标之间的间距 */
        padding: 2px 4px; /* 给一点内边距，避免 hover 背景太贴边 */        
        width: 100%; /* 占满 pane 宽度 */
      }

      /* 标题文字，防止换行 */
      .tab-title {
        white-space: nowrap;
        max-width: 120px; /* 可选：限制最大宽度 */
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /* 删除图标的基础样式 */
      .tab-close-icon {
        font-size: 15px;
        color: #999; /* 默认灰色 */
        cursor: pointer;
        opacity: 10;   /* 【核心】默认完全隐藏 */
        transition: all 0.2s ease;
        padding: 0px;
        border-radius: 2px;
        margin-left: 6px;
      }

      /* 鼠标悬停在删除图标上时：变红 */
      .tab-close-icon:hover {
        color: #ff4d4f;
        background-color: #fff1f0;
      }      
</style>